let linkStore;

export const setStore = store => linkStore = store;
export const dispatch = (...args) => linkStore.dispatch(...args);

export default {
  setStore,
  dispatch,
}
